import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomSnackbarService } from 'src/app/components/custom-notification/custom-notification.component';
import { ProductListingService } from 'src/app/service/product-listing.service';
import { RegisterService } from 'src/app/service/register.service';
import { ServiceListingService } from 'src/app/service/service-listing.service';
import { UtilityService } from 'src/app/service/utility.service';
import { ResponseStatus } from 'src/enum/responseEnum';

@Component({
  selector: 'app-service-listing',
  templateUrl: './service-listing.component.html',
  styleUrls: ['./service-listing.component.css'],
})
export class ServiceListingComponent {
  @ViewChild('searchInput') searchInput: any;
  title = 'Service  <span>Listing</span>';
  title1 = 'Kraft Designs';
  title2 = 'Add new Service';
  title3 = 'Edit Service';
  title4 = 'Service details';
  class1 = 'profile-banner';
  userBusinessDetails: any = []
  currentPage: number = 1;
  pageLimit: number = 5;
  pageSearch: string = '';
  totalRecords: number = 1;
  services: any[] = [];
  loading: boolean = true;
  showEditCard: number = 0
  showDetailsCard: number = 0;
  showAddPopup: boolean = false;
  showDeleteModel: number = 0;
  filterForm: any = FormGroup;
  description: string = '';
  showDescription: boolean = false;
  addToFavLoader: number | null = null;
  //selectedOption: string = "";
  selectedOption: string[] = [];
  filteredOptions: any[] = [];
  searchBusiness: string = "";
  defaultFilterValues: any = {
    productTypeId: [""],
    businessName: [""],
    dateFrom: [""],
    dateTo: [""],
    validationStatusId: [""],
    productCategoryId: [""],
  }
  businessList: any = {
    loading: false,
    response: null,
    error: ''
  };
  categoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  productTypes: any = {
    loading: false,
    response: null,
    error: ''
  };
  productStatus: any = {
    loading: false,
    response: null,
    error: ''
  };
  approvedOnly:boolean = false;
  statusLoading: number = 0;

  toggleErrorPopup: boolean = false;
  toggleErrorMsg = ''

  modalOption!: NgbModalOptions;

  constructor(private serviceListingService: ServiceListingService, private customSnackbarService: CustomSnackbarService,
    private register: RegisterService, private router: Router, private fb: FormBuilder, private activatedroute: ActivatedRoute,
    private utility : UtilityService, private elementRef : ElementRef, private renderer : Renderer2,
    private _adapter: DateAdapter<any>,
    private _intl: MatDatepickerIntl,
    @Inject(MAT_DATE_LOCALE) private _locale: string,) {

    this.modalOption = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      windowClass: 'ToggleCustomClass'
    }

      this._adapter.setLocale('in');
    this.approvedOnly = this.activatedroute.snapshot.data['approvedOnly'];
    this.filterForm = this.fb.group(this.defaultFilterValues);
    if(this.approvedOnly){
      this.filterForm.get("validationStatusId").setValue(2)  // for approved only right now we have status id as 14 it may change in future
      this.title = 'Approved <span>Services</span>'
    }
    this.getProductCategories()
    this.getProductTypes()
    this.getProductApproval();
  }

  onSearchInput(event: Event): any {
    this.searchBusiness = (event.target as HTMLInputElement).value.toLowerCase();
    this.getBusinessList(this.searchBusiness)

  }


  onSelectOpenChange(isOpen: boolean): any {
    if (isOpen) {
      // Reset filtered options when the dropdown is opened
      this.filteredOptions = this.businessList.response;
    }
  }

  handleStatus(event:any, product:any){
    if(this.statusLoading){
      return
    }
    this.statusLoading = product.productId;
    event.preventDefault()
    event.stopImmediatePropagation()
    this.serviceListingService.statusUpdate(product.productId,product.productStatus === "Active"? "InActive" : "Active" ).then((res: any) => {

    if(res.data.status === 'SUCCESS') {
      this.getServiceList();
    }
    else {
      this.toggleErrorPopup = true;
     this.toggleErrorMsg = res.data.desc;
    }
    }).catch((err: any) => {
      this.statusLoading = 0
    })
  }

  showStatus(product:any){
    return product?.productStatus === 'Active' ? true : false
  }

  getBusinessList(search: string) {
    this.businessList = {
      ...this.businessList,
      loading: true,
      error: ''
    }
    const params = {
      type: "SERVICE",
      search
    }
    this.serviceListingService.getBusinessList(params).then((res: any) => {
      this.businessList = {
        ...this.businessList,
        loading: false,
        response: res.data.records,
      }
      this.filteredOptions = res.data.records
    }).catch((err: any) => {
      this.businessList = {
        ...this.businessList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
      this.filteredOptions = []
    })
  }
  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: ''
    }
    this.serviceListingService.getProductCategories().then((res: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  handleFilter() {
    this.pageSearch = "";
    this.currentPage = 1;
    this.getServiceList()
  }

  getProductTypes() {
    this.productTypes = {
      ...this.productTypes,
      loading: true,
      error: ''
    }
    this.serviceListingService.getServiceType().then((res: any) => {
      this.productTypes = {
        ...this.productTypes,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productTypes = {
        ...this.productTypes,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductApproval() {
    this.productStatus = {
      ...this.productStatus,
      loading: true,
      error: ''
    }
    this.serviceListingService.getProductApproval().then((res: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductStatus() {
    this.productStatus = {
      ...this.productStatus,
      loading: true,
      error: ''
    }
    this.serviceListingService.getProductStatus().then((res: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  resetFilter() {
    this.filterForm.get("businessName").setValue("")
    this.filterForm.get("productTypeId").setValue("");
    this.filterForm.get("dateFrom").setValue("");
    this.filterForm.get("dateTo").setValue("");
    this.filterForm.get("productCategoryId").setValue("");
    if(this.approvedOnly){
      this.filterForm.get("validationStatusId").setValue(2); // for approved only right now we have status id as 14 it may change in future
    }else{
      this.filterForm.get("validationStatusId").setValue("")
    }

    if (this.searchInput) {
      this.searchInput.nativeElement.value = ''; // Clear the input field
      this.getBusinessList(this.searchInput)
    }
    this.getServiceList()
    this.currentPage = 1;
    this.pageSearch = "";
  }
  addProductToFavorites(productVariantId: number, type: number) {
    if (this.addToFavLoader != null) {
      return
    }
    this.addToFavLoader = productVariantId;
    let favType = type == 0 ? 1 : 0
    this.serviceListingService.addServiceToFavorites(productVariantId, favType).then((res: any) => {
      this.getServiceList();
      if (res.data.desc) {
        this.customSnackbarService.openCustomSnackbar(res.data.desc, 30000, true);
        this.addToFavLoader = null;
      }
    }).catch((err: any) => {
      this.addToFavLoader = null;
    })
  }
  showDiv: number | null = null;

  // toggleDiv() {
  //   this.showDiv = !this.showDiv;
  // }

  openDiv(event: any, index: number) {
    // event.preventDefault()
    event.stopImmediatePropagation();
    if (this.showDiv === null) {
      this.showDiv = index;

    } else {
      this.showDiv = null;
    }
  }
  closeDiv() {
    if (this.showDiv !== null) {
      this.showDiv = null;

    }
  }
  handleDelete() {
    if (this.showDeleteModel) {
      this.serviceListingService.deleteProduct(this.showDeleteModel).then(() => {
        this.currentPage = 1;
        this.getServiceList();
        this.showDeleteModel = 0;
        this.customSnackbarService.openCustomSnackbar('The service has been deleted successfully.', 30000);
      })
    }
  }
  handleEdit(status: number) {
    this.showEditCard = status;
  }

  getUserDetails() {
    this.loading = true;
    this.register.fetchUserDetails().then((res) => {
      if (res.status = ResponseStatus.SUCCESS) {
        this.userBusinessDetails = res.data;
        this.loading = false;
      }
    })
  }
  handleview(status: number) {
    this.showDetailsCard = status;
  }
  resetEditListing() {
    this.showEditCard = 0;
    this.getServiceList();
  }

  handleProductApprove(id: number) {
    this.serviceListingService.approveProduct(id).then((d: any) => {
      this.getServiceList();
      this.showDetailsCard = 0;
      this.customSnackbarService.openCustomSnackbar(d.data.desc, 30000);
    }).catch(() => {
      this.showDetailsCard = 0;
      this.customSnackbarService.openCustomSnackbar("Unable to update, please try later.", 30000, true);
    })
  }

  handleProductReject(id: number) {
    this.serviceListingService.rejectProduct(id).then((r: any) => {
      this.getServiceList();
      this.showDetailsCard = 0;
      this.customSnackbarService.openCustomSnackbar(r.data.desc, 30000);
    }).catch(() => {
      this.showDetailsCard = 0;
      this.customSnackbarService.openCustomSnackbar("Unable to update, please try later.", 30000, true);
    })
  }
  getServiceList() {

    const x: any = {
      // serviceTypeId: this.filterForm.value.productTypeId
      ...(this.filterForm.value?.businessName && this.filterForm.value?.businessName.length > 0 ? { businessNameIn: this.filterForm.value?.businessName } : {}),
      ...(this.filterForm.value?.productCategoryId && this.filterForm.value?.productCategoryId.length > 0 ? { productCategoryIdIn: this.filterForm.value?.productCategoryId } : {}),
      ...(this.filterForm.value?.validationStatusId && this.filterForm.value?.validationStatusId.length > 0 ? { validationStatusIdIn: this.filterForm.value?.validationStatusId } : {}),
      ...(this.filterForm.value.dateFrom
        ? { dateFromGrEq: this.utility.dateFormatter(this.filterForm.value.dateFrom) }
        : {}),
      ...(this.filterForm.value.dateTo
        ? { dateToLsEq: this.utility.dateFormatter(this.filterForm.value.dateTo) }
        : {}),
    }
    delete(x.productTypeId)
    this.serviceListingService
      .getServiceListing(this.pageSearch, this.currentPage, this.pageLimit, x)
      .then((res: any) => {
        this.services = res.data.records;
        this.totalRecords = res.data?.totalRecords;
        this.loading = false;
        this.addToFavLoader = null;
        this.statusLoading = 0;
      })
      .catch((err: any) => {
        this.loading = false;
        this.addToFavLoader = null;

        console.log(err);
      });
  }
  searchProductOnChange(event: any) {
    // if (value.target.value) {
    //   this.currentPage = 1;
    //   this.pageSearch = value.target.value;
    // }
    // else {
    //   this.pageSearch = "";
    // }

    // this.getServiceList();

    const val = event.target.value;
    this.currentPage = 1;
    this.pageSearch = val;

    this.getServiceList();
  }

  clearSearch() {
    this.pageSearch = '';
    this.getServiceList();
  }


  ngOnInit() {
    this.getServiceList();
    this.getUserDetails()
  }

  showProductDescription(des: string) {
    this.description = des;
    this.showDescription = true;
  }

  onPageChange(page: any) {
    this.currentPage = page;
    this.getServiceList();
  }

  onPageSizeChange(page: any) {
    this.pageLimit = page;
    this.currentPage = 1;
    this.getServiceList();
  }

  handleAddService(status: boolean) {
    this.showAddPopup = status;
  }

  resetListing() {
    this.showAddPopup = false;
    console.log('here')
    this.currentPage = 1;
    this.getServiceList();
  }
  getProductShortDescription(des: any) {
    return false
    if (des && des.length > 40) {
      return true;
    } else {
      return false;
    }
  }

  popUpEventHander(event : any){
   this.onPreview(event.url,event.value);
  }

  preview : number = 0;
  previewImg : string = '';
  onPreview(url : string,value : number) : void {
    this.preview = value;
    this.previewImg = url;
      const parentElement = this.elementRef.nativeElement.querySelector('.addpro');
      if (parentElement) {
        const childElement = parentElement.querySelector('.modal-content');
        if (childElement) {
          if(value){
            this.renderer.addClass(childElement, 'fifty');
          }else{
            this.renderer.removeClass(childElement, 'fifty');
          }
        }
      }
  }



  hideModel() {
    this.toggleErrorPopup = false;
    this.statusLoading = 0
  }
}
